package floris.graphics.landing.pages.projects

import floris.graphics.core.utils.MVI
import floris.graphics.models.domain.models.project.ProjectDetail
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

interface ProjectContract : MVI<ProjectContract.State, ProjectContract.Intent, ProjectContract.Effect> {
    data class State(
        val project: ProjectDetail? = null,
        val nextProjectId: String? = null,
        val previousProjectId: String? = null,
        val headerMarginTop: CSSSizeValue<CSSUnit.px> = 0.px,
        val showProjectNavigators: Boolean = false
    )

    sealed class Intent {
        data object LoadProjectDetails : Intent()
        data class Navigate(val route: String) : Intent()
    }

    sealed class Effect {
        data class NavigateToNextScreen(val route: String) : Effect()
        data class ShowError(val message: String) : Effect()
    }
}
